module.exports = __webpack_public_path__ + "static/media/running.a991a4ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/instanceScreenshotViewer/instances/instanceControlPanel/maintenanceMonitor/maintenanceCommand/symbols/running.svg
// module id = 906
// module chunks = 0